import React from "react";
import RegisterWrapper from "../../Components/Wrappers/RegisterWrapper";
import Input from "../../UI/Input";
import Button from "../../UI/Button";

export default function CreatePasswordScreen({
  handleSubmit,
  passwordToggle,
  handlePasswordChange,
  passwordConfirmToggle,
  handlePasswordConfirmChange,
  isButtonDisabled,
    passwordValidation,
    passwordConfirmValidation
}) {
  return (
    <RegisterWrapper image="/assets/images/register-2.svg">
      <h1 className="register__title">Create new password</h1>
      <p className="register__p mt8">
        Please enter a new password. Your new password must be different from
        previous password.
      </p>

      <form onSubmit={handleSubmit} className="register__form">
        <div className="register__input mt20">
          <Input
            id="password"
            label="Create password"
            placeholder="Enter password"
            type={passwordToggle.type}
            toggleType={passwordToggle.toggleType}
            icon={passwordToggle.icon}
            value={passwordValidation.value}
            handleChange={handlePasswordChange}
          />
        </div>
        <div className="register__input mt20">
          <Input
            id="password_confirm"
            label="Confirm new password"
            placeholder="Enter password confirm"
            type={passwordConfirmToggle.type}
            toggleType={passwordConfirmToggle.toggleType}
            icon={passwordConfirmToggle.icon}
            value={passwordConfirmValidation.value}
            handleChange={handlePasswordConfirmChange}
          />
        </div>
        <div className="register__btn mt24">
          <Button
            text="Create password"
            type="primary"
            disabled={isButtonDisabled}
            topPadding={12}
            bottomPadding={12}
          />
        </div>
      </form>
    </RegisterWrapper>
  );
}
